import { render, staticRenderFns } from "./CompareRecursive.vue?vue&type=template&id=63f7614c&scoped=true&"
import script from "./CompareRecursive.vue?vue&type=script&lang=ts&"
export * from "./CompareRecursive.vue?vue&type=script&lang=ts&"
import style0 from "./CompareRecursive.vue?vue&type=style&index=0&id=63f7614c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f7614c",
  null
  
)

export default component.exports